module.exports = __webpack_public_path__ + "static/media/especial2.c53fde15.png";